const isObject = (value) => Boolean(value) && typeof value === "object" && !Array.isArray(value);

const pruneEmpty = (value) => {
  if (!isObject(value)) {
    return null;
  }

  const entries = Object.entries(value).filter(([, entryValue]) => {
    if (entryValue === null || entryValue === undefined || entryValue === "") {
      return false;
    }
    if (isObject(entryValue)) {
      return Object.keys(entryValue).length > 0;
    }
    return true;
  });

  if (!entries.length) {
    return null;
  }

  return Object.fromEntries(entries);
};

export const isFailedRunAttempt = (attempt) => String(attempt?.status || "").toLowerCase() === "failed";

export const extractRunAttemptErrorMessage = (attempt) =>
  String(attempt?.error_message || attempt?.response_json?.error?.message || "").trim() || null;

export const buildRunAttemptDiagnostics = (attempt) => {
  const responseJson = attempt?.response_json;
  if (!isObject(responseJson)) {
    return null;
  }

  const errorDetails = pruneEmpty({
    http_status: responseJson?.error?.status,
    code: responseJson?.error?.code || attempt?.error_code || null,
    type: responseJson?.error?.type || null,
    param: responseJson?.error?.param || null,
    request_id: responseJson?.error?.request_id || null,
  });

  return pruneEmpty({
    provider: responseJson.provider || attempt?.provider_key || null,
    model: responseJson.model || attempt?.model_key || null,
    failure_kind: responseJson.failure_kind || null,
    hint: responseJson.hint || null,
    error: errorDetails,
  });
};

export const resolveRunAttemptResultPayload = (attempt) => {
  if (attempt?.output_json) {
    return attempt.output_json;
  }

  const responseJson = attempt?.response_json;
  if (!isObject(responseJson)) {
    return responseJson || null;
  }

  if (isFailedRunAttempt(attempt) && (responseJson.error || responseJson.failure_kind || responseJson.hint)) {
    return null;
  }

  return responseJson;
};
